module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-9.14509419.jpg";